var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFF",
    d: "M39.374 36.219l-9.826-9.825c4.94-6.422 4.446-15.698-.888-21.571C24.827 1.584 20.655.6 16.428.6 12.201.6 8.29 1.584 4.79 4.823c-6.421 6.422-6.421 16.851 0 24.127 3.5 2.384 7.411 3.976 11.638 3.976 3.513 0 7.027-1.098 9.936-3.349l9.881 9.771c.439.439.988 1.252 1.592 1.252.549 0 1.153-.813 1.592-1.252.823-.824.823-1.378-.055-3.129zM16.483 28.48c-3.239 0-6.203-1.263-8.509-3.513-4.666-4.666-4.666-12.295 0-17.015a11.954 11.954 0 018.509-3.513c3.239 0 6.203 1.262 8.509 3.513 2.305 2.25 3.513 5.269 3.513 8.507 0 3.239-1.263 6.203-3.513 8.508-2.251 2.305-5.325 3.513-8.509 3.513z"
  })));
}

export default SvgSearch;